import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store/types";
import { SelectChangeEvent } from "@mui/material/Select/SelectInput";
import {
  ApplyButtonStyle,
  ApplyButtonWrapper,
  CloseIconStyle,
  DropdownLabelStyle,
  FormControlStyle,
  ModalContentStyle,
  SelectStyle,
  closeButtonStyle,
} from "./style";
import { changeUploadSellerSelected } from "store/catalogTracker/catalogTracker.slice";

interface SellerSelectModalProps {
  handleClose: Function;
  isOpen: boolean;
}

export const SellerSelectModal: React.FC<SellerSelectModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const [localSelected, setLocalSelected] = React.useState(false);

  const selectedSellers = useSelector(
    (state: AppState) => state.auth.selectedSellers
  );

  const handleSelectSeller = (e: SelectChangeEvent<"">) => {
    dispatch(changeUploadSellerSelected(e.target.value));
    if (e.target.value) {
      setLocalSelected(true);
    }
  };

  const handleCloseModal = () => {
    handleClose();
    dispatch(changeUploadSellerSelected(""));
  };

  const handleSelect = () => {
    handleClose();
  };

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalContentStyle}>
          <IconButton onClick={handleCloseModal} sx={closeButtonStyle}>
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
          <FormControl sx={FormControlStyle}>
            <InputLabel sx={DropdownLabelStyle}>Select seller</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              placeholder="Test"
              onChange={handleSelectSeller}
              label="Select seller"
              sx={SelectStyle}
            >
              {selectedSellers.map((item) => {
                return <MenuItem value={item.id}>{item.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <Box sx={ApplyButtonWrapper}>
            <Button
              sx={ApplyButtonStyle}
              disabled={!localSelected}
              onClick={handleSelect}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
